import React, { useState, useEffect } from 'react';
import '../styles/App.css';
import '../styles/responsive.css';
import SmallFooter from '../components/SmallFooter';
import BrandLink from '../components/BrandLink';
import { LINKS } from '../constants';
import SamBento from '../img/Sam_Bento_2025.png';
import SamDuRegger from '../img/Sam_DuRegger.jpg';
import BotLogo from '../img/bot.svg';



function AboutUs() {
  return (
	  <main>
		<BookSection />
		<TeamSection />
		<ContactSection />
	  </main>
	);
  }
  
  


const TeamSection = () => {
	const [bentoImage, setBentoImage] = useState(
	  window.innerWidth > 768 ? SamBento : SamDuRegger
	);
  
	useEffect(() => {
	  const handleResize = () => {
		setBentoImage(window.innerWidth > 768 ? SamBento : SamDuRegger);
	  };
  
	  window.addEventListener('resize', handleResize);
  
	  // Clean up the event listener when the component unmounts
	  return () => window.removeEventListener('resize', handleResize);
	}, []);
  
	return (
  <section className="team">
	  <div className="team-content">
	  <h1>Founder</h1>
	  <p>Sam DuRegger, the founder of Barista Bot, has 18+ years of experience in digital innovation as the Product Lead at YouVersion in 2008, which now boasts over 900 MM users, to growing an innovation team at Sonic Drive-In from a small team of three to multiple teams of developers, project managers, designers, and product managers. He has led Digital Transformation initiatives in the Fast Casual Restaurant, Government, and Banking sectors, helping transition teams, organizations, and agencies toward a more digital-centric process orientation.</p>
	  <p>Barista Bot is a product of <BrandLink href={LINKS.espressoPlusMilk}>Espresso + Milk, LLC</BrandLink>, alongside <BrandLink href={LINKS.brandMenuOps}>Menu-Ops</BrandLink> and <BrandLink href={LINKS.brandAllCaps}>ALL CAPS.</BrandLink></p>
	  </div>
	  <div className="bento">
	  <img src={bentoImage} alt="Sam DuRegger Bento Box" className="bento-image" />
	  </div>
	   <h3>Get in Touch</h3>
		<div className="team-contact-container">
				<div className="team-info-container">
				  <p>Are you a Seed Investor, Angel Investor, or VC looking to expand your portfolio? Schedule a  meeting over coffee with our founder to learn more about Barista Bot’s roadmap and capital structure.</p>
				</div>
				<div className="team-button-container">
				  <a href="https://calendar.app.google/kE1Qe9Ttqn9UKL8SA" target="_blank" rel="noopener noreferrer"><button className="char-button-stacked">Schedule Coffee ↗</button></a>
				  <a href="mailto:sam@beginthework.com" ><button className="char-button-stacked">Send An EMAIL ↗</button></a>
				</div>
			  </div>
  </section>
		  );
		};


const BookSection = () => {
	return (
		<section className="book-demo-section">
			<div className="book-demo-content-wrapper">
				<div className="book-demo-content">
					<h1>Book a Demo in OKC</h1>
					<p>See Barista Bot's Square POS integration in action. We'll walk through menu import, the ordering flow, and how emoji shortcuts work. Free coffee and a Barista Bot mug included.</p>
					<div className="book-demo-button-container">
						<a href="https://calendar.app.google/kE1Qe9Ttqn9UKL8SA" target="_blank" rel="noopener noreferrer">
							<button className="submit-button">Book a Demo in OKC ↗</button>
						</a>
					</div>
				</div>
				<div className="book-demo-map">
					<iframe
						src="https://www.google.com/maps?q=219+NW+12th+St+Suite+23+Oklahoma+City+OK+73103&output=embed"
						width="100%"
						height="300"
						style={{ border: 0, borderRadius: '24px' }}
						allowFullScreen=""
						loading="lazy"
						referrerPolicy="no-referrer-when-downgrade"
						title="Barista Bot Studio Location - 219 NW 12th St, Suite 23, Oklahoma City, OK 73103"
						className="book-demo-map-iframe"
					></iframe>
				</div>
			</div>
		</section>
	);
};


const ContactSection = () => {
	  return (
		  <>
		<section className="contact-section">
		  <div className="contact-header-wrapper">
			<h1>Are you a coffee shop?</h1>
			<div className="contact-logo-container">
				<img src={BotLogo} alt="Barista Bot Logo" className="contact-logo" />
			</div>
		  </div>
		  <div className="contact-content">
			  <p>Beta is open. If you use Square POS, join early and get instant access to our growing customer base. Your customers can sign up and order via text—no app download required.</p>
			  <p>Limited spots available. Be among the first coffee shops to offer text-based ordering.</p>
			  <a href="mailto:sam@beginthework.com" ><button className="submit-button">Join the Beta ↗</button></a>
			</div>
		</section>
		<SmallFooter />
		</>
	  );
	};


export default AboutUs;